module.exports = __webpack_public_path__ + "images/jennifer.jpg";